import './App.css';
import pattern from './assets/image/pattern.svg';
import { Route, Routes } from 'react-router-dom';
import Menu from './screens/menu/Menu';
import Home from './screens/home/Home';
import ConfigProvider from './context/config/ConfigProvider';
import NotFound from './screens/error/NotFound';
import ImagePopup from './components/popup/ImagePopup';

function App() {
    return (
        <ConfigProvider>
            <div className="app">
                <div className='pattern' style={{ backgroundImage: `url(${pattern})` }}></div>
                <ImagePopup />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="menu" element={<Menu />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </div>
        </ConfigProvider>
    );
}

export default App;
